import * as yup from 'yup';

const phoneRegExp = /^(?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}$/;

export const getRegisterCompanyStepSchema = yup.object().shape({
  name: yup.string().required('Ce champs est requis'),
  legalStatutes: yup.string().required('Ce champs est requis'),
  plan: yup.string().required('Ce champs est requis'),
  address: yup.string().required('Ce champs est requis'),
  city: yup.string().required('Ce champs est requis'),
  postalCode: yup.string().required('Ce champs est requis'),
  department: yup.string().required('Ce champs est requis'),
  region: yup.string().required('Ce champs est requis'),
  latitude: yup.number(),
  longitude: yup.number(),
  siret: yup
    .string()
    .matches(/^[0-9]+$/, "Ce champs ne peut contenir que des chiffres")
    .min(14, 'Vous devez renseigner 14 chiffres')
    .max(14, 'Vous devez renseigner 14 chiffres')
    .required('Ce champs est requis'),
  tva: yup.string(),
  firstName: yup.string().required('Ce champs est requis'),
  lastName: yup.string().required('Ce champs est requis'),
  email: yup.string().email().required('Ce champs est requis'),
  phone: yup
    .string()
    .matches(phoneRegExp, 'Numéro de téléphone invalide')
    .required('Ce champs est requis'),
  function: yup.string().required('Ce champs est requis'),
  // useSameInfos: yup.boolean(),
  // firstName_owner: yup.string().required('Ce champs est requis'),
  // lastName_owner: yup.string().required('Ce champs est requis'),
  email_owner: yup
    .string()
    .email(),
    // .required('Ce champs est requis'),
  phone_owner: yup
    .string()
    .matches(phoneRegExp, 'Numéro de téléphone invalide')
    // .required('Ce champs est requis'),
  // function_owner: yup.string().required('Ce champs est requis'),
});
